import React from "react";
import { useSelector } from "react-redux";

import Modal from "./Modal";
import Loading from "components/Loader/Spinner";
import CustomSpinner from "components/Loader/CustomSpinner";
import {
  BACKGROUND_WALLET,
  MODAL_CLOSE,
  COMPLETE_TRANSACTION,
  FAILED_TRANSACTION,
} from "src/constants/images";
import { replaceFloatValue } from "utils/replaceFloatValue";

const Loader = ({ cost, icxInUSD }) => (
  <>
    <div className="header">
      <img
        src={BACKGROUND_WALLET.SOURCE}
        alt="background"
        className="background-wallet"
      />
      {cost > 0 ? (
        <h4 className="mb-2">Wallet connected!</h4>
      ) : (
        <h4 className="mb-2">Wallet connected!</h4>
      )}

      {cost > 0 ? (
        <p className="text">
          Total Price: <strong>{cost} ICX </strong>
          (${replaceFloatValue(cost * icxInUSD)})
        </p>
      ) : null}
    </div>
    <div className="body loading">
      <CustomSpinner />
    </div>
    <div className="footer">
      {cost > 0 ? (
        <p className="py-2">
          {`Posting for sale at`} {cost} ICX ($
          {replaceFloatValue(icxInUSD * cost)}) <br /> Please wait.
        </p>
      ) : (
        <p className="py-2">
          {`Removing from listing.`} <br />
          Please wait..
        </p>
      )}

      <button disabled className="btn btn-outline-secondary close">
        Close
      </button>
    </div>
  </>
);

const Success = ({ onClick, cost, icxInUSD }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-3">Success!</h4>
      {cost > 0 ? (
        <p className="text">
          You successfully listed your GangstaBet at {cost} ICX ($
          {replaceFloatValue(icxInUSD * cost)}).
        </p>
      ) : (
        <p className="text">
          You successfully removed your GangstaBet listing.
        </p>
      )}
    </div>
    <div className="body">
      <img
        src={COMPLETE_TRANSACTION.SOURCE}
        alt="transaction completed"
        className="d-block mx-auto my-3"
      />

      <button
        className="btn btn-outline-primary profile"
        onClick={() => onClick("sale")}
      >
        Close
      </button>
    </div>
  </>
);

const Cancel = ({ onClick }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-2 me-2 ms-md-0">Oh No! Transaction Cancelled</h4>
      <p className="text my-3">Transaction cancelled.</p>
    </div>
    <div className="body">
      <span className="d-block mx-auto my-3 failed-transaction">
        <img
          src={FAILED_TRANSACTION.SOURCE}
          alt="transaction failed"
          className="mb-0"
        />
      </span>
      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const Error = ({ onClick, message }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-2 me-2 ms-md-0">Oh No! Transaction Failed</h4>
      <p className="text my-3">
        Could not complete due to transaction failure, please try again after
        sometime!
        <br />
        {message}
      </p>
    </div>
    <div className="body">
      <span className="d-block mx-auto my-3 failed-transaction">
        <img
          src={FAILED_TRANSACTION.SOURCE}
          alt="transaction failed"
          className="mb-0"
        />
      </span>
      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const SalePriceLoader = ({ response, onClick, isVisible, cost }) => {
  const icxInUSD = useSelector((state) => state.icxPricing.price);

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="buying-modal card px-3 py-4"
    >
      {response.status === "success" ? (
        <Success onClick={onClick} cost={cost} icxInUSD={icxInUSD} />
      ) : response.status === "cancel" ? (
        <Cancel onClick={onClick} />
      ) : response.status === "error" ? (
        <Error onClick={onClick} />
      ) : (
        <Loader cost={cost} icxInUSD={icxInUSD} />
      )}
    </Modal>
  );
};

export default SalePriceLoader;
